export function getRatingsWidgetPresentation({
  loading,
  error,
  refreshing,
  availabilityStatus,
  availabilityMessage,
  dataUnavailable,
  restrictedMessage,
}) {
  const recalculating = availabilityStatus === 'recalculating';
  const failed =
    availabilityStatus === 'failed' || (!!dataUnavailable && !recalculating);
  const empty = availabilityStatus === 'empty';

  let message = '';
  if (restrictedMessage) {
    message = restrictedMessage;
  } else if (recalculating) {
    message =
      availabilityMessage ||
      'Ratings are being recalculated. This usually takes a moment.';
  } else if (failed) {
    message =
      availabilityMessage ||
      'Recalculation failed. Please try again or contact support.';
  } else if (empty) {
    message =
      availabilityMessage ||
      'Nothing to display for the current widget settings.';
  }

  return {
    loading: !!loading && !refreshing && !recalculating,
    refreshing: !!refreshing && !recalculating,
    recalculating,
    error: !!error || failed,
    unavailable: !!restrictedMessage,
    empty,
    message,
  };
}
